import styled from "styled-components";

export const NoPastAppointments = styled.div`
   font-size: 14px;
   &.mobile-section-css {
      padding: 20px;
   }
`;
